import {useEffect, useState} from "react";
import {AboutUsData} from "../types/Page";
import api from "../../api";
import Header from "./Components/Header";
import PageHero from "./Components/PageHero";
import FeaturedSection from "./Components/FeaturedSection";
import AboutUsSection from "./Components/AboutUsSection";
import Footer from "./Components/Footer";

function AboutUs() {
    const [aboutUsData, setAboutUsData] = useState<AboutUsData | null>(null);

    async function fetchAboutUsData() {
        try {
            const res = await api.get('/v1/about');
            setAboutUsData(res.data);
        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        fetchAboutUsData()
    }, []);

    return (
        <div>
            <Header />
            {aboutUsData && aboutUsData.page && aboutUsData.page.headers && <PageHero headers={aboutUsData.page.headers} page={"about-us"}/>}

            {/*  About Us Main Section  */}
            {aboutUsData && aboutUsData.page && aboutUsData.page.about_us && aboutUsData.different && aboutUsData.why_choose && (
                <AboutUsSection about_us={aboutUsData.page.about_us} why_choose={aboutUsData.why_choose} different={aboutUsData.different} />
            )}
            <div style={{marginTop: "50px"}} />

            {/*  About us Featured Section  */}
            {aboutUsData && aboutUsData.page && aboutUsData.page.feature_cards && <FeaturedSection featured_cards={aboutUsData?.page.feature_cards} background_color={"#ffffff"} card_color={"#FFD100"} font_color={"#000"} border_color={"#FFD100"} page={"about-us"}/> }

            <Footer />
        </div>
    )
}

export default AboutUs;
